import { Card, Col, Row, Skeleton } from "antd";
import QueueAnim from "rc-queue-anim";
import OverPack from "rc-scroll-anim/lib/ScrollOverPack";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import NotNeedAuthService from "../../Services/notNeedAuth.service";
import { getChildrenToRender } from "./utils";

function Feature7(props) {
  useEffect(() => {
    const array = [];
    // eslint-disable-next-line no-unused-vars
    let isMounted = true;
    NotNeedAuthService.getAPIProductCategoryList().then((response) => {
      for (var i = 0; i <= response.Data.length - 1; i++) {
        var CategoryName = response.Data[i].Name;
        //var CategoryType = response.Data[i].CategoryType;
        var CategoryDescription = response.Data[i].CategoryDescription;
        var CategoryHref = "/APIs/SG/" + CategoryName.replace(/\s/g, "-");
        array.push({
          name: CategoryName,
          //type: CategoryType,
          desc: CategoryDescription,
          href: CategoryHref,
        });
      }
      setCategory(array);
      setLoading(false);
    });
    return () => {
      isMounted = false;
    };
  }, []);

  const [categoryList, setCategory] = useState([]);
  const { dataSource, isMobile, ...tagProps } = props;
  const { titleWrapper } = dataSource;
  const [loading, setLoading] = useState(true);

  const item_list = (array) => [
    <Col xs={24} sm={24} md={24} lg={8} xl={8} key={array.name}>
      <Card
        title={array.name}
        className="APIEACH"
        style={{ minHeight: "200px" }}
      >
        <p style={{ height: "35px" }}>{array.desc}</p>
        <br />
        <Link to="/APIs">Documentation</Link>
      </Card>
    </Col>,
  ];

  const render = (
    <Row gutter={[24, 24]} justify="start">
      {categoryList
        .sort((a, b) => (b.name > a.name ? 1 : -1))
        .map((array) => [item_list(array)])}
    </Row>
  );
  return (
    <div {...tagProps} {...dataSource.wrapper}>
      <div {...dataSource.page}>
        <div {...dataSource.titleWrapper}>
          {titleWrapper.children.map(getChildrenToRender)}
        </div>
        <OverPack {...dataSource.OverPack}>
          <QueueAnim key="queue" type="bottom" leaveReverse interval={50}>
            {loading === false ? (
              render
            ) : (
              <>
                <Skeleton active />
                <br />
              </>
            )}
          </QueueAnim>
        </OverPack>
      </div>
    </div>
  );
}

export default Feature7;
